export const regionalCourses = {
  tamil: {
    animation: [
      {
        id: 'regionals-tamil-courses/introduction-to-programming-in-tamil',
        courseID: 'introduction-to-programming-in-tamil',
        title: 'Introduction to Programming',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/introduction-to-computers.png',
        imgName: 'Introduction in தமிழ்',
        desc: 'Kick-start your coding journey in தமிழ்',
        planID: 'introduction-to-programming-in-tamil-yearly-inr',
        pathID: 'introduction-to-programming-in-tamil-package',
        freeCourse: true,
      },
      {
        id: 'regionals-tamil-courses/python-in-tamil',
        courseID: 'python-in-tamil',
        title: 'Python',
        img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/python.png',
        imgName: 'Python in தமிழ்',
        desc: 'Learn python from scratch in தமிழ்',
        planID: 'python-in-tamil-yearly-inr',
        pathID: 'python-in-tamil-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-tamil-courses/c-programming-in-tamil',
        courseID: 'c-programming-in-tamil',
        title: 'C Programming',
        img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/c-programming.png',
        imgName: 'C in தமிழ்',
        desc: 'Master C programming in தமிழ்',
        planID: 'c-programming-in-tamil-yearly-inr',
        pathID: 'c-programming-in-tamil-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-tamil-courses/data-structure-in-tamil',
        courseID: 'data-structure-in-tamil',
        title: 'Data Structures C',
        img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/data-structures-in-c.png',
        imgName: 'DataStructures in தமிழ்',
        desc: 'Master Data Structures C in தமிழ்',
        planID: 'data-structure-in-tamil-yearly-inr',
        pathID: 'data-structure-in-tamil-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-tamil-courses/algorithms-in-tamil',
        courseID: 'algorithms-in-tamil',
        title: 'Algorithms C',
        img: '/Assets/navIcons/coursesNavIcons/AlgoCIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/algorithms.png',
        imgName: 'Algorithms in தமிழ்',
        desc: 'Master Algorithms C in தமிழ்',
        planID: 'algorithms-in-tamil-yearly-inr',
        pathID: 'algorithms-in-tamil-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-tamil-courses/problem-solving-beginners-in-tamil',
        courseID: 'problem-solving-beginners-in-tamil',
        title: 'Problem Solving Beginners',
        img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/problem-solving-beginners.png',
        imgName: 'PB_Beginners in தமிழ்',
        desc: `Let's solve basic coding problems in தமிழ்`,
        planID: 'problem-solving-beginners-in-tamil-yearly-inr',
        pathID: 'problem-solving-beginners-in-tamil-package',
        freeCourse: true,
      },
      {
        id: 'regionals-tamil-courses/problem-solving-with-dsa-in-tamil',
        courseID: 'problem-solving-with-dsa-in-tamil',
        title: 'Problem Solving with DSA',
        img: '/Assets/navIcons/coursesNavIcons/ProblemSolvingDSAIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemSolvingDSAIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/dsa-problems.png',
        imgName: 'PB_DSA in தமிழ்',
        desc: 'Problem-solving made easy with DSA in தமிழ்',
        planID: 'problem-solving-with-dsa-in-tamil-yearly-inr',
        pathID: 'problem-solving-with-dsa-in-tamil-package',
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-tamil-courses/recursion-in-tamil',
        courseID: 'recursion-in-tamil',
        title: 'Recursion',
        img: '/Assets/navIcons/coursesNavIcons/RecursionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/RecursionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/recursion.png',
        imgName: 'Recursion in தமிழ்',
        desc: 'Recursive programming made simple in தமிழ்',
        planID: 'recursion-in-tamil-yearly-inr',
        pathID: 'recursion-in-tamil-package',
        pricing: { IN: '₹999' },
      },
    ],
    professional: [
      {
        id: 'regionals-tamil-courses/core-java-in-tamil',
        courseID: 'core-java-in-tamil',
        title: 'Core Java',
        img: '/Assets/navIcons/expertNavIcons/CoreJavaIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CoreJavaIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/coreJavaPoster.png',
        imgName: 'Core Java',
        desc: 'Master Java programming fundamentals in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/java-8-in-tamil',
        courseID: 'java-8-in-tamil',
        title: 'Java 8',
        img: '/Assets/navIcons/expertNavIcons/Java8Icon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/Java8IconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/java8Poster.png',
        imgName: 'Java8',
        desc: 'Explore Java 8 features in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/jsp-servlet-in-tamil',
        courseID: 'jsp-servlet-in-tamil',
        title: 'JSP and Servlet',
        img: '/Assets/navIcons/expertNavIcons/JSPServletIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/JSPServletIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/JSPServletPoster.png',
        imgName: 'JSP and Servlet',
        desc: 'Build dynamic web applications in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/spring-in-tamil',
        courseID: 'spring-in-tamil',
        title: 'Spring',
        img: '/Assets/navIcons/expertNavIcons/JavaSpringIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/JavaSpringIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/SpringPoster.png',
        imgName: 'Spring Tamil',
        desc: 'Create robust Java applications in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/design-patterns-in-tamil',
        courseID: 'design-patterns-in-tamil',
        title: 'Design Patterns in Java',
        img: '/Assets/navIcons/expertNavIcons/DesignPatternsIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DesignPatternsIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/designPatternPoster.png',
        imgName: 'Design Patterns Java',
        desc: 'Implement Java design patterns in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/r-programming-data-science-in-tamil',
        courseID: 'r-programming-data-science-in-tamil',
        title: 'R for Data Science',
        img: '/Assets/navIcons/expertNavIcons/RforDataScienceIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/RforDataScienceIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/RPoster.png',
        imgName: 'R for DataScience',
        desc: 'Analyze data with R in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/excel-in-tamil',
        courseID: 'excel-in-tamil',
        title: 'Excel',
        img: '/Assets/navIcons/expertNavIcons/ExcelIcon.svg',
        whiteImg: '/Assets/navIcons/partnersNavIconsWhite/ExcelIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/ExcelPoster.png',
        imgName: 'Excel',
        desc: 'Excel spreadsheet skills mastery in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/selenium-in-tamil',
        courseID: 'selenium-in-tamil',
        title: 'Selenium',
        img: '/Assets/navIcons/expertNavIcons/SeleniumIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/SeleniumIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/SeleniumPoster.png',
        imgName: 'Selenium',
        desc: 'Automate web application testing in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/node-js-in-tamil',
        courseID: 'node-js-in-tamil',
        title: 'Node Js',
        img: '/Assets/navIcons/expertNavIcons/NodeJsIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/NodeJsIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/NodeJSPoster.png',
        imgName: 'NodeJs',
        desc: 'Build scalable server applications in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/django-in-tamil',
        courseID: 'django-in-tamil',
        title: 'Django',
        img: '/Assets/navIcons/expertNavIcons/DjangoIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DjangoIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/DjangoPoster.png',
        imgName: 'Django',
        desc: 'Streamline web app creation in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/android-in-tamil',
        courseID: 'android-in-tamil',
        title: 'Android',
        img: '/Assets/navIcons/expertNavIcons/AndroidIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AndroidIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/AndroidPoster.png',
        imgName: 'Android',
        desc: 'Create Android mobile apps in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/react-in-tamil',
        courseID: 'react-in-tamil',
        title: 'React Js',
        img: '/Assets/navIcons/expertNavIcons/ReactIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ReactIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/ReactPoster.png',
        imgName: 'React',
        desc: 'Build interactive web interfaces in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/react-native-in-tamil',
        courseID: 'react-native-in-tamil',
        title: 'React Native',
        img: '/Assets/navIcons/expertNavIcons/ReactNatvieIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ReactNatvieIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/ReactNativePoster.png',
        imgName: 'ReactNatvie',
        desc: 'Develop cross-platform mobile apps in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/kotlin-in-tamil',
        courseID: 'kotlin-in-tamil',
        title: 'Kotlin',
        img: '/Assets/navIcons/expertNavIcons/KotinIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/KotinIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/KotlinPoster.png',
        imgName: 'Kotin',
        desc: 'Modern Android development language in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/flutter-in-tamil',
        courseID: 'flutter-in-tamil',
        title: 'Flutter',
        img: '/Assets/navIcons/expertNavIcons/FlutterIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/FlutterIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/FlutterPoster.png',
        imgName: 'Flutter',
        desc: 'Create beautiful mobile interfaces in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/ruby-in-tamil',
        courseID: 'ruby-in-tamil',
        title: 'Ruby',
        img: '/Assets/navIcons/expertNavIcons/RubyIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/RubyIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/RubyPoster.png',
        imgName: 'Ruby',
        desc: 'Learn versatile Ruby programming in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/rails-in-tamil',
        courseID: 'rails-in-tamil',
        title: 'Rails',
        img: '/Assets/navIcons/expertNavIcons/RailsIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/RailsIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/RailsPoster.png',
        imgName: 'Rails',
        desc: 'Develop with Ruby on Rails in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/php-in-tamil',
        courseID: 'php-in-tamil',
        title: 'PHP',
        img: '/Assets/navIcons/expertNavIcons/PHPIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PHPIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/PHPPoster.png',
        imgName: 'PHP',
        desc: 'Master server-side scripting in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/database-in-tamil',
        courseID: 'database-in-tamil',
        title: 'Database',
        img: '/Assets/navIcons/expertNavIcons/DatabaseIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DatabaseIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/DatabasePoster.png',
        imgName: 'Database',
        desc: 'Manage and optimize databases in தமிழ்',
        pricing: { IN: '₹499' },
      },
      {
        id: 'regionals-tamil-courses/javascript-in-tamil',
        courseID: 'javascript-in-tamil',
        title: 'JavaScript',
        img: '/Assets/navIcons/expertNavIcons/JsIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/JsIconWhite.svg',
        cardImg: '/Assets/ExpertCourseCards/JavascriptPoster.png',
        imgName: 'Javascript',
        desc: 'Drive interactive web experiences in தமிழ்',
        pricing: { IN: '₹499' },
      },
    ],
  },
  telugu: {
    animation: [
      {
        id: 'regionals-telugu-courses/introduction-to-programming-in-telugu',
        courseID: 'introduction-to-programming-in-telugu',
        title: 'Introduction to Programming',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/introduction-to-computers.png',
        imgName: 'Introduction in తెలుగు',
        desc: 'Kick-start your coding journey in తెలుగు',
        planID: 'introduction-to-programming-in-telugu-yearly-inr',
        pathID: 'introduction-to-programming-in-telugu-package',
        freeCourse: true,
      },
      {
        id: 'regionals-telugu-courses/python-in-telugu',
        courseID: 'python-in-telugu',
        title: 'Python',
        img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/python.png',
        imgName: 'Python in తెలుగు',
        desc: 'Learn python from scratch in తెలుగు',
        planID: 'python-in-telugu-yearly-inr',
        pathID: 'python-in-telugu-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-telugu-courses/c-programming-in-telugu',
        courseID: 'c-programming-in-telugu',
        title: 'C Programming',
        img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/c-programming.png',
        imgName: 'C in తెలుగు',
        desc: 'Master C programming in తెలుగు',
        planID: 'c-programming-in-telugu-yearly-inr',
        pathID: 'c-programming-in-telugu-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-telugu-courses/data-structure-in-telugu',
        courseID: 'data-structure-in-telugu',
        title: 'Data Structures C',
        img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/data-structures-in-c.png',
        imgName: 'DataStructures in తెలుగు',
        desc: 'Master Data Structures C in తెలుగు',
        planID: 'data-structure-in-telugu-yearly-inr',
        pathID: 'data-structure-in-telugu-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-telugu-courses/algorithms-in-telugu',
        courseID: 'algorithms-in-telugu',
        title: 'Algorithms C',
        img: '/Assets/navIcons/coursesNavIcons/AlgoCIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/algorithms.png',
        imgName: 'Algorithms in తెలుగు',
        desc: 'Master Algorithms C in తెలుగు',
        planID: 'algorithms-in-telugu-yearly-inr',
        pathID: 'algorithms-in-telugu-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-telugu-courses/problem-solving-beginners-in-telugu',
        courseID: 'problem-solving-beginners-in-telugu',
        title: 'Problem Solving Beginners',
        img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/problem-solving-beginners.png',
        imgName: 'PB_Beginners in తెలుగు',
        desc: `Let's solve basic coding problems in తెలుగు`,
        planID: 'problem-solving-beginners-in-telugu-yearly-inr',
        pathID: 'problem-solving-beginners-in-telugu-package',
        freeCourse: true,
      },
      {
        id: 'regionals-telugu-courses/problem-solving-with-dsa-in-telugu',
        courseID: 'problem-solving-with-dsa-in-telugu',
        title: 'Problem Solving with DSA',
        img: '/Assets/navIcons/coursesNavIcons/ProblemSolvingDSAIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemSolvingDSAIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/dsa-problems.png',
        imgName: 'PB_DSA in తెలుగు',
        desc: 'Problem-solving made easy with DSA in తెలుగు',
        planID: 'problem-solving-with-dsa-in-telugu-yearly-inr',
        pathID: 'problem-solving-with-dsa-in-telugu-package',
        pricing: { IN: '₹999' },
      },
    ],
  },
  hindi: {
    animation: [
      {
        id: 'regionals-hindi-courses/introduction-to-programming-in-hindi',
        courseID: 'introduction-to-programming-in-hindi',
        title: 'Introduction to Programming',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/introduction-to-computers.png',
        imgName: 'Introduction in हिन्दी',
        desc: 'Kick-start your coding journey in हिन्दी',
        planID: 'introduction-to-programming-in-hindi-yearly-inr',
        pathID: 'introduction-to-programming-in-hindi-package',
        freeCourse: true,
      },
      {
        id: 'regionals-hindi-courses/python-in-hindi',
        courseID: 'python-in-hindi',
        title: 'Python',
        img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/python.png',
        imgName: 'Python in हिन्दी',
        desc: 'Learn python from scratch in हिन्दी',
        planID: 'python-in-hindi-yearly-inr',
        pathID: 'python-in-hindi-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-hindi-courses/c-programming-in-hindi',
        courseID: 'c-programming-in-hindi',
        title: 'C Programming',
        img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/c-programming.png',
        imgName: 'C in हिन्दी',
        desc: 'Master C programming in हिन्दी',
        planID: 'c-programming-in-hindi-yearly-inr',
        pathID: 'c-programming-in-hindi-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-hindi-courses/data-structure-in-hindi',
        courseID: 'data-structure-in-hindi',
        title: 'Data Structures C',
        img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/data-structures-in-c.png',
        imgName: 'DataStructures in हिन्दी',
        desc: 'Master Data Structures C in हिन्दी',
        planID: 'data-structure-in-hindi-yearly-inr',
        pathID: 'data-structure-in-hindi-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-hindi-courses/algorithms-in-hindi',
        courseID: 'algorithms-in-hindi',
        title: 'Algorithms C',
        img: '/Assets/navIcons/coursesNavIcons/AlgoCIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/AlgoCIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/algorithms.png',
        imgName: 'Algorithms in हिन्दी',
        desc: 'Master Algorithms C in हिन्दी',
        planID: 'algorithms-in-hindi-yearly-inr',
        pathID: 'algorithms-in-hindi-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-hindi-courses/problem-solving-with-dsa-in-hindi',
        courseID: 'problem-solving-with-dsa-in-hindi',
        title: 'Problem Solving with DSA',
        img: '/Assets/navIcons/coursesNavIcons/ProblemSolvingDSAIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemSolvingDSAIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/dsa-problems.png',
        imgName: 'PB_DSA in हिन्दी',
        desc: 'Problem-solving made easy with DSA in हिन्दी',
        planID: 'problem-solving-with-dsa-in-hindi-yearly-inr',
        pathID: 'problem-solving-with-dsa-in-hindi-package',
        pricing: { IN: '₹999' },
      },
      {
        id: 'regionals-hindi-courses/coding-interview-patterns-in-hindi',
        courseID: 'coding-interview-patterns-in-hindi',
        title: 'Coding Interview Patterns',
        img: '/Assets/navIcons/coursesNavIcons/InterviewPatternIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/InterviewPatternIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/coding-interview-patterns.png',
        imgName: 'Interview Patterns in हिन्दी',
        desc: 'Popular coding interview patterns in हिन्दी',
        planID: '',
        pathID: 'coding-interview-patterns-hindi',
        pricing: { IN: '₹999' },
      },
    ],
  },
  kannada: {
    animation: [
      {
        id: 'regionals-kannada-courses/introduction-to-programming-in-kannada',
        courseID: 'introduction-to-programming-in-kannada',
        title: 'Introduction to Programming',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/introduction-to-computers.png',
        imgName: 'Introduction in ಕನ್ನಡ',
        desc: 'Kick-start your coding journey in ಕನ್ನಡ',
        planID: '',
        pathID: 'introduction-to-programming-in-kannada-package',
        freeCourse: true,
      },
      {
        id: 'regionals-kannada-courses/python-in-kannada',
        courseID: 'python-in-kannada',
        title: 'Python',
        img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/python.png',
        imgName: 'Python in ಕನ್ನಡ',
        desc: 'Learn python from scratch in ಕನ್ನಡ',
        planID: 'python-in-kannada-yearly-inr',
        pathID: 'python-in-kannada-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-kannada-courses/c-programming-in-kannada',
        courseID: 'c-programming-in-kannada',
        title: 'C Programming',
        img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/c-programming.png',
        imgName: 'C in ಕನ್ನಡ',
        desc: 'Master C programming in ಕನ್ನಡ',
        planID: 'c-programming-in-kannada-yearly-inr',
        pathID: 'c-programming-in-kannada-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-kannada-courses/data-structure-in-kannada',
        courseID: 'data-structure-in-kannada',
        title: 'Data Structures in C',
        img: '/Assets/navIcons/coursesNavIcons/DSACIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/DSACIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/data-structures-in-c.png',
        imgName: 'DataStructures in ಕನ್ನಡ',
        desc: 'Master Data Structures C in ಕನ್ನಡ',
        planID: 'data-structure-in-kannada-yearly-inr',
        pathID: 'data-structure-in-kannada-package',
        isPricing: true,
        indianPrice: {
          listPrice: 3999,
          offerPrice: 999,
        },
        pricing: { IN: '₹999' },
      },
    ],
  },
  bengali: {
    animation: [
      {
        id: 'regionals-bengali-courses/introduction-to-programming-in-bengali',
        courseID: 'introduction-to-programming-in-bengali',
        title: 'Introduction to Programming',
        img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/IntroductionIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/introduction-to-computers.png',
        imgName: 'Introduction in বাংলা',
        desc: 'Kick-start your coding journey in বাংলা',
        planID: '',
        pathID: 'introduction-to-programming-in-bengali-package',
        freeCourse: true,
      },
      {
        id: 'regionals-bengali-courses/python-in-bengali',
        courseID: 'python-in-bengali',
        title: 'Python',
        img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/PythonIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/python.png',
        imgName: 'Python in বাংলা',
        desc: 'Learn python from scratch in বাংলা',
        planID: 'python-in-bengali-yearly-inr',
        pathID: 'python-in-bengali-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
      {
        id: 'regionals-bengali-courses/c-programming-in-bengali',
        courseID: 'c-programming-in-bengali',
        title: 'C Programming',
        img: '/Assets/navIcons/coursesNavIcons/CPrgIcon.svg',
        whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CPrgIconWhite.svg',
        cardImg: '/Assets/courseNewIcon/c-programming.png',
        imgName: 'C in বাংলা',
        desc: 'Master C programming in বাংলা',
        planID: 'c-programming-in-bengali-yearly-inr',
        pathID: 'c-programming-in-bengali-package',
        isPricing: true,
        indianPrice: {
          listPrice: 2999,
          offerPrice: 999,
        },
        pricing: { IN: '₹499' },
        // specialOffer: true,
      },
    ],
  },
};
